import React from 'react';
import { css } from 'emotion';
import { Room, Phone, Email, Facebook, Instagram } from '@material-ui/icons';
import OptInMap from './OptInMap';

function Info() {
  return (
    <div className={style.container} id="info">
      <div className={style.info}>
        <div className={style.title}>Haardbeat</div>
        <div className={style.subtitle}>Julia Schneider</div>
        <br />
        <a
          href="https://www.google.com/maps/place/Haardbeat+by+Julia/@48.41629,9.11062,16z/data=!4m5!3m4!1s0x0:0xcb9add2336bf41f6!8m2!3d48.41629!4d9.11062?hl=de"
          target="_blank"
          rel="noopener noreferrer"
          className={style.link}
        >
          <div
            className={css`
              ${style.infoLine};
              padding-bottom: 5px;
            `}
          >
            <div>
              <Room className={style.icon} />
            </div>
            <div>
              Im Raiken 3
              <br />
              72116 M&ouml;ssingen-&Ouml;schingen
            </div>
          </div>
        </a>

        <a href="tel:+4974737734" className={style.link}>
          <div className={style.infoLine}>
            <div>
              <Phone className={style.icon} />
            </div>
            <div>07473 7734</div>
          </div>
        </a>
        <a href="mailto:info@haardbeat.de" className={style.link}>
          <div className={style.infoLine}>
            <div>
              <Email className={style.icon} />
            </div>
            <div>info@haardbeat.de</div>
          </div>
        </a>
        <a href="https://www.facebook.com/haardbeat/" target="_blank" rel="noopener noreferrer" className={style.link}>
          <div className={style.infoLine}>
            <div>
              <Facebook className={style.icon} />
            </div>
            <div>@haardbeat</div>
          </div>
        </a>
        <a href="https://www.instagram.com/haardbeat_" target="_blank" rel="noopener noreferrer" className={style.link}>
          <div className={style.infoLine}>
            <div>
              <Instagram className={style.icon} />
            </div>
            <div>@haardbeat_</div>
          </div>
        </a>
      </div>
      <div className={style.map}>
        <OptInMap />
      </div>
    </div>
  );
}

const style = {
  container: css`
    display: flex;
    justify-content: space-between;
    @media (max-width: 640px) {
      flex-direction: column;
    }
  `,
  info: css`
    width: calc(50% - 20px);
    padding: 10px;
    @media (max-width: 640px) {
      width: calc(100% - 20px);
    }
  `,
  map: css`
    width: calc(50% - 20px);
    height: 300px;
    padding: 10px;
    @media (max-width: 640px) {
      width: calc(100% - 20px);
    }
    @media (max-width: 460px) {
      height: 250px;
    }
  `,
  googleMaps: css`
    width: 100%;
    height: 350px;
    border: 0;
    @media (max-width: 460px) {
      height: 250px;
    }
  `,
  title: css`
    font-size: 24px;
  `,
  subtitle: css`
    font-size: 14px;
  `,
  infoLine: css`
    display: flex;
    line-height: 20px;
    cursor: pointer;
    &:hover {
      color: #d30e39;
    }
  `,
  icon: css`
    font-size: 20px !important;
    margin-right: 3px;
  `,
  link: css`
    font-style: normal;
    text-decoration: none;
    color: inherit;
  `,
};

export default Info;
